import API from '../../lib/api'
import Vue from 'vue'
import crudModule from "./crudModule";

const module = crudModule('Connectivity', '/status');

module.actions['fetch'] = async ({commit}, {facilityId, service, days = 14}) => {
    commit('setFetching', true);

    const response = await API.request('GET', module.path + `/${facilityId}/days/${days}?service=${service}`);

    if (response.success === true) {
        commit('setList', response.data.items);
    } else {
        Vue.prototype.$alert.error(`Failed to fetch ${module.itemName.toLowerCase()} list`);
        commit('setList', []);
    }

    commit('setFetching', false);
};

export default module;